/*
 * Lemonade Training Oy, copy rights, all right reserved.
 */

/** Keys the dashboard writes per box; must match the queue hook's prefix. */
const UNSETTLED_STORAGE_PREFIX = "lemonade-unsettled-requests";

/**
 * Drop every box's unfinished-settlement markers.
 *
 * These record which members a gym still owes money, so they are the previous
 * signed-in owner's business and no one else's. Cleared on sign-out for the
 * same reason the image-variant cache is: a shared machine must not carry one
 * user's state into the next user's session.
 */
export const clearUnsettledRequestMarkers = () => {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    const doomed = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(`${UNSETTLED_STORAGE_PREFIX}:`)) doomed.push(key);
    }
    doomed.forEach((key) => window.localStorage.removeItem(key));
  } catch {
    // A blocked or unavailable store must never break sign-out.
  }
};
